
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, Output, DOCUMENT } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertPopup, HttpLoader, path } from 'app/app.config';
import { ChatService } from 'app/components/chat-list/chat.service';
import { jsPDF } from "jspdf";
import { AssistBotService } from '../../assist-bot.service';
import { DialogService } from 'app/services/dialog.service';
import { ListdialogComponent } from 'app/core/listdialog/listdialog.component';
import { saveAs as importedSaveAs } from "file-saver";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AiAssistComponent } from '../../ai-assist.component';
import { LlmService } from 'app/services/llm.service';
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';

import Quill from "quill";

import ImageResize from 'quill-image-resize';
import { ActivatedRoute } from '@angular/router';
import { finalize, Observable } from 'rxjs';
Quill.register("modules/resize", ImageResize);

export interface QueryResponse {
  response: string;
  sources: any[];
  queried_document_ids: string[];
  source_paragraphs: any[];
}

export interface QueryItem {
  answer?: string;
  response?: string;
  sources?: any[];
  queried_document_ids?: string[];
  source_paragraphs?: any[];
}

export interface SaveHistoryPayload {
  user_id: string | null;
  question: string[];
  answer: string;
  query_type?: string;
  document_ids?: any;
  source_paragraphs?: any[];
  source_doc?: string;
}


declare const $: any;

@Component({
  selector: 'app-bot',
  templateUrl: './bot.component.html',
  styleUrls: ['./bot.component.scss'],
  standalone: false
})
export class BotComponent {
  profileUrl = path.PROFILE_URL;
  volumeicons: any = ["pi pi-volume-off", "pi pi-volume-up"];
  @Input() data: any;
  @Input() userDetail: any;
  @Input() index: any;
  @Input() speakeLanguage: any;
  @Output() copyText: EventEmitter<any> = new EventEmitter();
  @Output() PingChat: EventEmitter<any> = new EventEmitter();
  @Output() Like: EventEmitter<any> = new EventEmitter();
  @Output() Dislike: EventEmitter<any> = new EventEmitter();
  showPaginateSpinner: boolean = false;
  showSpinner: boolean = false;

  multipleAnswers: boolean = false;
  multipleAnswersData: any[] = [];

  showModal = false;
  editAIData: any;
  editBotHistoryId: any;
  editingAnswerIndex: number = -1; // Track which answer item is being edited when multipleAnswers is true

  public isActiveFeedback: boolean = false;
  public isInActiveFeedback: boolean = false;
  // Track feedback state per answerItem index
  public answerItemFeedbackState: { [key: number]: { active: boolean, inactive: boolean } } = {};

  synth = window.speechSynthesis;
  showTextView: boolean = false;
  commentForm: FormGroup = new FormGroup({});
  showuserIcon: boolean = false;

  // base_url:any = `http://115.246.210.90:8502`;
  llm_url: any;
  doc_uuid: any;
  safeHtml!: SafeHtml;
  documentFileName: any;
  documentFileNameError: any;
  source_doc: any;
  editorFullView: boolean = false;
  is_generic: boolean = false;
  usercomments: any;
  editor_modules: any;
  quill: any;
  isPin: boolean = false;
  isSpeak: string = 'off';
  document_id: any;
  stateCode: any;
  cleanedSourceParagraphs: SafeHtml = '';

  documentSearch: boolean = false;
  mode: any;
  searchView: boolean = false;


  private streamAnswers: string[] = [];
  private streamSources: any[][] = [];
  private streamSourceDocs = new Set<string>();

  private currentStreamQuestionIndex = 0;
  private completedStreamQuestions = 0;

  private streamHistorySaved = false;


  constructor(private fb: FormBuilder, @Inject(DOCUMENT) private document: Document, private alert: AlertPopup, private http: HttpClient, private chatService: ChatService, private assistBotService: AssistBotService, private dialogService: DialogService, private httpLoader: HttpLoader, private sanitizer: DomSanitizer, private aiassistsComp: AiAssistComponent, private llmService: LlmService, private route: ActivatedRoute, private confirmDialogService: ConfirmationDialogService) {

  }

  ngOnInit(): void {
    this.initializeComponent();

    if (!this.shouldTriggerSearch()) return;

    const questionArray = this.prepareQuestions();
    const userId = this.getUserId();

    this.is_generic
      ? this.handleGenericQuery(questionArray, userId)
      : this.handlePrivateQuery(questionArray, userId);
  }

  private getUserId(): string {
    return localStorage.getItem('user_id') ?? '';
  }

  private initializeComponent(): void {
    this.llmService.restoreLLMBotPayload();
    this.cleanSourceParagraphs();

    const payload = this.llmService.llm_bot_payload || {};

    this.setPayloadData(payload);
    this.initForm();
    this.handleExistingAnswer();
  }

  private setPayloadData(payload: any): void {
    this.document_id = payload?.document_id ?? null;
    this.mode = payload?.mode ?? 'answer';

    const modelType = payload?.model_type ?? 0;

    this.documentSearch = modelType === 1;
    this.is_generic = !this.assistBotService.queryType?.library;
  }

  private initForm(): void {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required]
    });
  }

  private handleExistingAnswer(): void {
    if (this.data?.bot_answer) {
      this.showPaginateSpinner = false;
    }
  }

  private shouldTriggerSearch(): boolean {
    return !!this.data?.search && this.data?.bot_type !== 'suggestion';
  }

  private prepareQuestions(): string[] {
    const { questionArray, question } = this.data || {};

    // Prefer pre-built array if valid
    if (Array.isArray(questionArray) && questionArray.length > 0) {
      return questionArray.map(q => q?.trim()).filter(Boolean);
    }

    // Fallback to splitting string
    if (typeof question === 'string') {
      return question
        .split(',')
        .map(q => q.trim())
        .filter(Boolean);
    }

    return [];
  }

  private handleGenericQuery(questionArray: string[], userId: string | null): void {
    const query = this.data?.question?.trim();

    if (!query) return;

    this.executeApiCall(
      this.llmService.llmGenericQuery({ query }),
      (res: any) => {
        const answer = res?.formatted_response ?? '';

        this.data.bot_answer = answer;
        this.data.query_type = 'generic';

        this.saveHistory({
          user_id: userId,
          question: questionArray,
          answer,
          query_type: 'generic'
        });
      }
    );
  }

  private executeApiCall(apiCall: Observable<any>, callback: (res: any) => void): void {
    this.showPaginateSpinner = true;

    apiCall.subscribe({
      next: (res) => {
        this.showPaginateSpinner = false;
        callback(res);
      },
      error: () => {
        this.showPaginateSpinner = false;
      }
    });
  }

  private handlePrivateQuery(questionArray: string[], userId: string | null): void {
    const modelType = this.llmService.llm_bot_payload?.model_type;

    if (this.documentSearch) {
      return this.callUploadSearch(questionArray, userId);
    }

    switch (modelType) {
      case 1:
        return this.callSimpleQuery(questionArray, userId);

      case 2:
        return this.callAdvancedQuery(questionArray, userId);

      case 3:
        return this.callSimpleQueryV3(questionArray, userId);

      case 4:
        return this.callSimpleQueryV4(questionArray, userId);

      default:
        console.warn('Unknown model type:', modelType);
    }
  }

  private buildQueryPayload(questionArray: string[]) {
    return {
      query: questionArray,
      bypass_cache: true,
      mode: this.mode,
      client_id: localStorage.getItem('company_id') ?? '',
      doc_id: this.document_id
    };
  }

  private callUploadSearch(questionArray: string[], userId: string | null): void {
    const payload = {
      document_id: this.document_id?.toString(),
      question: questionArray,
      mode: this.mode
    };

    this.executeApiCall(
      this.llmService.llmsearchAndQAUploadSearch(payload),
      (res) => this.handleMultipleResponses(res, questionArray, userId)
    );
  }

  private callSimpleQuery(questionArray: string[], userId: string | null): void {
    const payload = this.buildQueryPayload(questionArray);

    this.executeApiCall(
      this.llmService.llmSimpleQuery_v2(payload),
      (res) => {
        const answer = this.changeNewLine(res?.response ?? '');

        this.data.bot_answer = answer;
        this.data.source_doc = this.fileSources(res?.sources || []);
        this.data.query_type = 'private';

        this.saveHistory({
          user_id: userId,
          question: questionArray,
          answer,
          document_ids: res?.queried_document_ids,
          source_paragraphs: res?.source_paragraphs
        });
      }
    );
  }

  private callAdvancedQuery(questionArray: string[], userId: string | null): void {
    const payload = this.buildQueryPayload(questionArray);

    this.executeApiCall(
      this.llmService.llmQuery_v2(payload),
      (res) => this.handleMultipleResponses(res, questionArray, userId)
    );
  }

  private callSimpleQueryV3(questionArray: string[], userId: string | null): void {
    const payload = {
      question: questionArray,
      mode: this.mode,
      document_id: this.document_id?.join(', ')
    };

    this.executeApiCall(
      this.llmService.llmAdvancedQuery_v2(payload),
      (res) => this.handleMultipleResponses(res, questionArray, userId)
    );
  }

  private callSimpleQueryV4(
    questionArray: string[],
    userId: string | null
  ): void {

    if (!questionArray?.length) {
      return;
    }

    const payload = {
      message: questionArray[0],
      mode: this.mode,
      region: 'ALL',
      document_id: this.document_id?.join(', '),
      session_id: localStorage.getItem('session_id')
    };

    this.startMultiStreamingState(
      questionArray.length
    );

    this.showPaginateSpinner = true;
    this.data.isTyping = true;

    this.llmService
      .streamPrivateQuery1(payload)
      .subscribe({

        next: (event: any) => {

          this.handleMultiStreamEvent(
            event,
            questionArray,
            userId
          );

        },

        error: (error: any) => {

          console.error(
            'Private streaming error:',
            error
          );

          this.showPaginateSpinner = false;
          this.data.isTyping = false;
          this.data.stream_status = 'error';

        },

        complete: () => {

          console.log(
            'Private SSE connection completed'
          );

          this.showPaginateSpinner = false;
          this.data.isTyping = false;

          /*
           * Safety fallback.
           */
          if (
            !this.streamHistorySaved &&
            this.completedStreamQuestions ===
            questionArray.length
          ) {

            this.finalizeMultiStreamingResponse(
              questionArray,
              userId
            );
          }

        }

      });
  }

  private startMultiStreamingState(
    questionCount: number
  ): void {

    this.streamAnswers =
      new Array(questionCount).fill('');

    this.streamSources =
      new Array(questionCount)
        .fill(null)
        .map(() => []);

    this.streamSourceDocs.clear();

    this.currentStreamQuestionIndex = 0;

    this.completedStreamQuestions = 0;

    this.streamHistorySaved = false;

    this.data.bot_answer = '';
    this.data.answer = '';

    this.data.source_doc = '';
    this.data.source_paragraphs = [];
    this.data.text = '';

    this.data.query_type = 'private';

    this.data.stream_status = 'started';

    this.data.stream_tool = null;

    this.data.isTyping = true;
  }

  private handleMultiStreamEvent(
    event: any,
    questionArray: string[],
    userId: string | null
  ): void {

    const eventType =
      event?.event ||
      event?.type ||
      '';

    const eventData =
      event?.data || {};

    console.log(
      '[MULTI SSE]',
      eventType,
      eventData
    );

    switch (eventType) {

      case 'tool':

        this.handleMultiStreamTool(
          eventData
        );

        break;

      case 'sources':

        this.handleMultiStreamSources(
          eventData
        );

        break;

      case 'token':

        this.handleMultiStreamToken(
          eventData
        );

        break;

      case 'done':

        this.handleMultiStreamDone(
          questionArray,
          userId
        );

        break;

      default:

        console.warn(
          'Unknown SSE event:',
          eventType
        );

        break;
    }
  }

  private handleMultiStreamTool(
    data: any
  ): void {

    this.data.stream_tool = {

      status:
        data?.status || '',

      name:
        data?.name || '',

      query:
        data?.query || ''

    };

    this.data.stream_status =
      data?.status || '';
  }

  private handleMultiStreamSources(
    data: any
  ): void {

    const sources =
      Array.isArray(data?.sources)
        ? data.sources
        : [];

    const index =
      this.currentStreamQuestionIndex;

    const mappedSources =
      sources.map((source: any) => {

        const paragraph = {

          document_name:
            source?.filename || '',

          section_title:
            source?.section_title || '',

          page:
            source?.page ?? '',

          score:
            source?.score ?? 0,

          text:
            source?.text || ''

        };

        if (paragraph.document_name) {

          this.streamSourceDocs.add(
            paragraph.document_name
          );

        }

        return paragraph;

      });

    this.streamSources[index] = mappedSources;

    this.updateMultiStreamSources();
  }

  private handleMultiStreamToken(
    data: any
  ): void {

    const token =
      data?.text ?? '';

    if (!token) {
      return;
    }

    const index =
      this.currentStreamQuestionIndex;

    this.streamAnswers[index] += token;

    /*
     * Update current answer immediately.
     */
    this.updateMultiStreamAnswer();

    this.data.isTyping = true;
  }


  private handleMultiStreamDone(
    questionArray: string[],
    userId: string | null
  ): void {

    const completedIndex =
      this.currentStreamQuestionIndex;

    console.log(
      `Question ${completedIndex + 1} completed`
    );

    this.completedStreamQuestions++;

    /*
     * More questions remaining.
     */
    if (
      this.currentStreamQuestionIndex <
      questionArray.length - 1
    ) {

      this.currentStreamQuestionIndex++;

      console.log(
        `Starting question ${this.currentStreamQuestionIndex + 1
        }`
      );

      return;
    }

    /*
     * All questions completed.
     */
    this.finalizeMultiStreamingResponse(
      questionArray,
      userId
    );
  }

  private updateMultiStreamAnswer(): void {

    const answers =
      this.streamAnswers
        .map(answer =>
          this.changeNewLine(answer)
        )
        .filter(answer => answer);

    this.data.bot_answer =
      answers.join(
        '<hr class="my-3">'
      );

    this.data.answer =
      this.data.bot_answer;
  }

  private updateMultiStreamSources(): void {

    const allSources =
      this.streamSources.flat();

    this.data.source_paragraphs =
      allSources;

    this.data.source_doc =
      Array.from(
        this.streamSourceDocs
      ).join(', ');

    this.data.text =
      this.fileSources_para_text(
        allSources
      );
  }

  private finalizeMultiStreamingResponse(
    questionArray: string[],
    userId: string | null
  ): void {

    if (this.streamHistorySaved) {
      return;
    }

    /*
     * Safety check.
     */
    if (
      this.completedStreamQuestions <
      questionArray.length
    ) {

      console.warn(
        'Not all streaming questions completed'
      );

      return;
    }

    this.streamHistorySaved = true;

    const combinedAnswer =
      this.streamAnswers
        .map(answer =>
          this.changeNewLine(answer)
        )
        .filter(answer => answer)
        .join('<hr class="my-3">');

    const allSourceParagraphs =
      this.streamSources.flat();

    const sourceDoc =
      Array.from(
        this.streamSourceDocs
      ).join(', ');

    /*
     * Final data.
     */
    this.data.bot_answer =
      combinedAnswer;

    this.data.answer =
      combinedAnswer;

    this.data.source_paragraphs =
      allSourceParagraphs;

    this.data.source_doc =
      sourceDoc;

    this.data.text =
      this.fileSources_para_text(
        allSourceParagraphs
      );

    this.data.query_type =
      'private';

    this.data.stream_status =
      'completed';

    this.data.isTyping =
      false;

    this.showPaginateSpinner =
      false;

    this.cleanSourceParagraphs();

    /*
     * Save ONE history record containing
     * all questions + all answers.
     */
    this.saveHistory({

      user_id:
        userId,

      question:
        questionArray,

      answer:
        combinedAnswer,

      source_doc:
        sourceDoc,

      source_paragraphs:
        allSourceParagraphs,

      query_type:
        'private'

    });

    console.log(
      'All streaming questions completed'
    );
  }

  private resetMultiStreamingState(): void {

    this.streamAnswers = [];

    this.streamSources = [];

    this.streamSourceDocs.clear();

    this.currentStreamQuestionIndex = 0;

    this.completedStreamQuestions = 0;

    this.streamHistorySaved = false;

    this.data.stream_tool = null;

    this.data.stream_status = '';

    this.data.isTyping = false;
  }

  private handleMultipleResponses(res: any, questionArray: string[], userId: string | null): void {

    let combinedAnswer = '';
    const allSourceParagraphs: any[] = [];
    const allSourceDocs = new Set<string>();
    const modelType = this.llmService.llm_bot_payload?.model_type;

    const responses = Array.isArray(res) ? res : [res];


    responses.forEach((response, index) => {

      const answer = this.mode === 'answer'
        ? this.changeNewLine(response?.answer || '')
        : this.getSearch(response?.source_paragraphs || []);

      if (index > 0) {
        combinedAnswer += '<hr class="my-3">';
      }

      combinedAnswer += answer;

      this.data.source_paragraphs = response?.source_paragraphs;

      const paragraphs: any = response?.source_paragraphs || [];
      allSourceParagraphs.push(...paragraphs);

      paragraphs.forEach((para: any) => {
        if (para?.document_name) {
          allSourceDocs.add(para.document_name);
        }
      });
    });



    this.cleanSourceParagraphs();


    // Single history save (FIXED)
    this.saveHistory({
      user_id: userId,
      question: questionArray,
      answer: combinedAnswer,
      source_paragraphs: allSourceParagraphs
    });

    this.data.bot_answer = combinedAnswer;
    this.data.source_doc = Array.from(allSourceDocs).join(', ');
    this.data.text = this.fileSources_para_text(allSourceParagraphs);
    this.data.query_type = 'private';

  }


  private saveHistory(data: SaveHistoryPayload): void {

    const sourceDoc =
      data.source_doc ||
      this.getUniqueDocumentNames(data.source_paragraphs) ||
      '';

    const payload = {
      user_id: data.user_id ?? '',
      question: data.question,
      answer: data.answer,
      question_type: 'history',
      bot_type: 'bot',
      source_doc: sourceDoc,
      sequence_id: Date.now(),
      query_type: data.query_type ?? 'private',
      document_ids: data.document_ids ?? [],
      source_paragraphs: data.source_paragraphs ?? []
    };

    this.assistBotService.createHistory(payload)
      .subscribe({
        next: (res: any) => {
          if (res?.success && res?.createdMessage) {
            this.updateHistoryState(res.createdMessage);
          }
        },
        error: (err) => {
          console.error('Save history failed:', err);
        }
      });
  }

  private updateHistoryState(message: any): void {
    this.data.sequence_id = message?.sequence_id;
    this.data.history_id = message?.history_id;
    this.data.createdAt = new Date();
    this.data.search = false;

    this.assistBotService.historyListBheaviour.next({
      templateName: 'bot'
    });
  }

  private getUniqueDocumentNames(paragraphs: any[] = []): string {
    return Array.from(
      new Set(
        paragraphs
          .map(p => p?.document_name)
          .filter(Boolean)
      )
    ).join(', ');
  }

  get questionText() {
    try {
      const parsed = JSON.parse(this.data?.question);

      console.log(parsed,);


      return parsed.question;
    } catch {
      return this.data?.question;
    }
  }

  speakText(state: boolean, textdata: string) {
    if (!('speechSynthesis' in window)) {
      console.log('Speech synthesis not supported in this browser.');
      return;
    }

    // Make sure synth is initialized
    if (!this.synth) {
      this.synth = window.speechSynthesis;
    }

    let voices = this.synth.getVoices();

    // Log available voices once (optional, for debugging)
    if (voices.length === 0) {
      console.warn("No voices found. Voices may load asynchronously.");
    }

    let speakLanguage: string;
    let defaultVoice: string;

    if (this.speakeLanguage === 'hindi') {
      speakLanguage = 'Google हिन्दी';
      defaultVoice = 'Microsoft Kalpana - Hindi (India)';
    } else if (this.speakeLanguage === 'spanish') {
      speakLanguage = 'Google español';
      defaultVoice = 'Microsoft Helena - Spanish (Spain)';
    } else {
      speakLanguage = 'Google US English';
      defaultVoice = 'Microsoft Zira - English (United States)';
    }

    let botVoice = voices.findIndex((v) => v.name === speakLanguage);
    let botDefaultVoice = voices.findIndex((v) => v.name === defaultVoice);

    // Clean text (remove HTML tags & &nbsp;)
    let text = textdata.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, " ").replaceAll(/\*/g, "").replaceAll(/\#/g, "");

    // Create utterance
    const utterThis = new SpeechSynthesisUtterance(text);
    utterThis.rate = 0.9; // Slightly faster than 0.5 for better pacing

    // Select voice
    utterThis.voice = botVoice > -1
      ? voices[botVoice]
      : botDefaultVoice > -1
        ? voices[botDefaultVoice]
        : voices[0]; // fallback to first available voice

    // Set language
    if (this.speakeLanguage === 'hindi') {
      utterThis.lang = 'hi-IN';
    } else if (this.speakeLanguage === 'spanish') {
      utterThis.lang = 'es-ES';
    } else {
      utterThis.lang = 'en-US';
    }

    if (state) {
      this.synth.cancel(); // stop any previous speech
      this.synth.speak(utterThis);
    } else {
      this.synth.cancel();
    }

    // Clean up toggle icon after speech ends
    const interval = setInterval(() => {
      if (!this.synth.speaking) {
        clearInterval(interval);
        document.querySelectorAll('.toggle-icon.is-active')
          .forEach((el) => el.classList.remove('is-active'));
      }
    }, 500);
  }

  showFeedbackform(index?: number) {
    if (index !== undefined) {
      // For multiple answers - track per item
      if (!this.answerItemFeedbackState[index]) {
        this.answerItemFeedbackState[index] = { active: false, inactive: false };
      }
      this.answerItemFeedbackState[index].active = true;
      this.answerItemFeedbackState[index].inactive = false;
    } else {
      // For single answer - use global state
      this.isActiveFeedback = true;
      this.isInActiveFeedback = false;
    }
    console.log(this.isActiveFeedback, 'isActive');
  }

  showInActiveFeedback(index?: number) {
    if (index !== undefined) {
      // For multiple answers - track per item
      if (!this.answerItemFeedbackState[index]) {
        this.answerItemFeedbackState[index] = { active: false, inactive: false };
      }
      this.answerItemFeedbackState[index].inactive = true;
      this.answerItemFeedbackState[index].active = false;
    } else {
      // For single answer - use global state
      this.isInActiveFeedback = true;
      this.isActiveFeedback = false;
    }
  }

  isAnswerItemActiveFeedback(index: number): boolean {
    return this.answerItemFeedbackState[index]?.active || false;
  }

  isAnswerItemInActiveFeedback(index: number): boolean {
    return this.answerItemFeedbackState[index]?.inactive || false;
  }

  submitForm() {
    this.alert.showAlertMessage({ "message": "Thanks for your feedback." });
    $('#inputField').focus();
  }

  copiedText(index: any) {
    this.copyText.emit(index);
  }

  PingedChat(index: any) {
    this.PingChat.emit(index);
    this.isPin = true;
  }

  Liked(index: any) {
    this.Like.emit(index);
  }

  Disliked(index: any) {
    this.Dislike.emit(index);
  }

  saveComment(items: any, accurate: any, index?: number) {
    this.confirmDialogService.openConfirmDialog('', {
      title: 'Confirm Submission',
      message: 'Are you sure you want to submit this feedback?',
      btnOkText: 'YES',
      btnCancelText: 'NO',
      onClose: (confirmed: boolean) => {
        if (confirmed) {
          this.submitFeedback(items, accurate, index);
        }
      }
    });
  }


  submitFeedback(items: any, accurate: any, index?: number): void {
    if (!items) {
      return;
    }

    this.showSpinner = true;

    const refId = Date.now();
    const userId = localStorage.getItem('user_id');

    const commentPayload = {
      history_id: items.history_id,
      type: 'comments',
      comments: this.commentForm.value['comment'] ?? '',
      sequence_id: refId,
      user_id: userId,
      question: Array.isArray(items.question)
        ? items.question.join(', ')
        : items.question ?? '',
      answer: items.bot_answer ?? '',
      query_type: items.query_type ?? '',
      accurate: accurate ?? '',
      source_doc: items.source_doc ? [items.source_doc] : ''
    };

    this.assistBotService.createComments(commentPayload).subscribe({
      next: (result: any) => {
        this.showSpinner = false;

        this.alert.showAlertMessage({
          message: 'Feedback submitted successfully'
        });

        if (index !== undefined) {
          // Reset feedback state for the selected answer
          if (this.answerItemFeedbackState?.[index]) {
            this.answerItemFeedbackState[index].active = false;
            this.answerItemFeedbackState[index].inactive = false;
          }
        } else {
          // Reset feedback state for a single answer
          this.isActiveFeedback = false;
          this.isInActiveFeedback = false;
        }

        this.commentForm.reset();
      },

      error: (error: any) => {
        this.showSpinner = false;

        console.error('Error saving feedback:', error);

        this.alert.showAlertMessage({
          message:
            error?.error?.message ||
            error?.message ||
            'Failed to save feedback. Please try again.'
        });
      }
    });
  }


  cancelComment(data?: any, index?: number) {
    if (index !== undefined) {
      // For multiple answers - reset per item
      if (this.answerItemFeedbackState[index]) {
        this.answerItemFeedbackState[index].active = false;
        this.answerItemFeedbackState[index].inactive = false;
      }
    } else {
      // For single answer - use global state
      this.isActiveFeedback = false;
      this.isInActiveFeedback = false;
    }
    this.commentForm.reset();
  }

  prepareCommentData(answerItem: any) {
    // Prepare question as array
    let questionArray = [];
    if (Array.isArray(answerItem.question)) {
      questionArray = answerItem.question;
    } else if (answerItem.question) {
      questionArray = [answerItem.question];
    }

    // Prepare document_ids from source_paragraphs
    let documentIds = '';
    if (answerItem.source_paragraphs && Array.isArray(answerItem.source_paragraphs)) {
      documentIds = answerItem.source_paragraphs
        .map((p: any) => p.document_id)
        .filter((id: any) => id)
        .join(',');
    }

    return {
      history_id: this.data.history_id,
      question: questionArray,
      bot_answer: answerItem.answer || '',
      query_type: this.data.query_type || '',
      document_ids: documentIds
    };
  }


  onKeypressEvent(event: any) {
    let comment = event.target.value;

    if ((event.code == "Enter") || (event.code == "NumpadEnter")) {
    }
  }
  downloadPDF(items: any) {

    var doc = new jsPDF();
    var img = new Image()
    img.src = '../assets/images/absence_gpt.png';
    doc.addImage(img, 'png', 0, 0, 100, 25);
    doc.setFont("sans-serif");
    doc.setTextColor('#000');
    doc.setFontSize(14);
    doc.text("Question:" + items.question, 15, 30);
    doc.setTextColor('#000');
    doc.setFontSize(11);

    items.bot_answer = items.bot_answer.replace(/<br\s*[\/]?>/gi, "\n");
    var splitTitle = doc.splitTextToSize(items.bot_answer, 185);
    doc.text(splitTitle, 15, 38);


    var userId = window.localStorage.getItem('user_id');

    doc.save(userId + '_' + 'assign' + new Date().getTime() + '.pdf');
    var blob = doc.output('blob');
    this.alert.showAlertMessage({ 'message': 'Answer downloaded' });
    console.log(blob);
  }

  changeNewLine(bot: any) {
    // if (bot?.hasOwnProperty("bot_answer")) {
    //   return bot['bot_answer']?.replaceAll(/\n/g, '<br>').replaceAll(/&nbsp;/g, " ").replaceAll(/\*/g, "").replaceAll(/\#/g, "");
    // } else {
    //   return bot?.replaceAll(/\n/g, '<br>').replaceAll(/&nbsp;/g, " ").replaceAll(/\*/g, "").replaceAll(/\#/g, "");
    // }
    return bot
  }

  ngAfterViewInit() {

    if (this.assistBotService.ChatCommentsList.length > 0) {
      let comments_filter = this.assistBotService.ChatCommentsList.filter((list: any) => list.history_id == this.data.history_id);

    }
    if (this.assistBotService.chatPinList.length > 0) {

      let pingfilter = this.assistBotService.chatPinList.filter((ping: any) => ping['sequence_id'] == this.data["sequence_id"]);
      if (pingfilter.length > 0) {
        this.isPin = true;
      }
    }

  }

  openEditAIModal(botData: any, answerIndex?: number) {
    this.editAIData = this.changeNewLine(botData["bot_answer"]);
    this.editBotHistoryId = botData.history_id;
    this.editingAnswerIndex = answerIndex !== undefined ? answerIndex : -1;
    this.showModal = true;

    // setTimeout(()=>{
    let content = document.getElementById("editor_" + this.data.history_id);
    let toolbarOptions = [
      ["bold",
        "italic",
        "underline",
        "strike",
        "image",
        "link"],
      [{ 'color': [] }, { 'background': [] }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ 'font': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
      [{ 'align': [] }],
      ['clean']
    ];
    this.quill = new Quill(content, {
      theme: "snow",
      modules: {
        toolbar: toolbarOptions,
        resize: {
          locale: {
            center: "center",
          },
        },
      },
    });


    // this.documentFileNameError="";

    this.quill.clipboard.dangerouslyPasteHTML(this.editAIData);
    //  },1500);


  }

  closeModal() {
    if (this.document.getElementsByClassName("ql-toolbar").length > 0) {
      this.document.getElementsByClassName("ql-toolbar")[0].remove();
    }
    this.showModal = false;
    this.quill = null;
    this.editingAnswerIndex = -1; // Reset the editing index when closing
  }

  saveEditAI(historyId: any, botData: any) {
    // Update the item logic here, possibly emitting event or calling a service
    // console.log('Saved:', this.editAIData);

    // const payload = {
    //     bot_answer: this.editAIData
    // }

    const payload = {
      bot_answer: this.quill.getSemanticHTML()
    }

    this.httpLoader.showLoader();
    this.assistBotService.updateAIBotHistory(historyId, payload).subscribe((response: any) => {

      console.log('updateAIBotHistory', response);


      if (this.multipleAnswers && this.editingAnswerIndex >= 0 && this.multipleAnswersData[this.editingAnswerIndex]) {
        this.multipleAnswersData[this.editingAnswerIndex].answer = response['data']['bot_answer'];

        // Also update the combined bot_answer in this.data
        let combinedAnswer = '';
        this.multipleAnswersData.forEach((item, index) => {
          if (this.mode == 'answer') {
            const answer = this.changeNewLine(item.answer);
            if (index > 0) {
              combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
            }
            combinedAnswer += answer;
          } else {
            const searchAnswer = this.getSearch(item.source_paragraphs);
            if (index > 0) {
              combinedAnswer += '<br><hr style="margin: 15px 0; border: none; border-top: 1px solid #ddd;"><br>';
            }
            combinedAnswer += searchAnswer;
          }
        });
        this.data['bot_answer'] = combinedAnswer;
      } else {

        this.data = response['data'];
      }

      console.log(this.data, 'data');
      this.closeModal();
      this.httpLoader.hideLoader();
      this.alert.showAlertMessage(response);
      this.editBotHistoryId = null;
      this.editingAnswerIndex = -1; // Reset the editing index
    });
    // this.closeModal();
  }

  refresh(): void {
    if (this.data?.bot_type === 'suggestion') return;

    this.data.createdAt = new Date();

    const userId = this.getUserId();
    const questionArray = this.prepareQuestions();

    this.is_generic = this.data?.query_type === 'generic';

    this.is_generic
      ? this.refreshGeneric(questionArray, userId)
      : this.refreshPrivate(questionArray, userId);
  }

  private refreshGeneric(questionArray: string[], userId: string): void {
    const query = this.data?.question?.trim();
    if (!query) return;

    this.executeApiCall(
      this.llmService.llmGenericQuery({ query }),
      (res) => {
        const answer = res?.formatted_response ?? '';

        this.updateBotData(answer, 'generic');

        this.refreshHistory(userId, questionArray, answer, '');
      }
    );
  }

  private refreshPrivate(questionArray: string[], userId: string): void {
    const payload = this.buildRefreshPayload(questionArray);

    this.executeApiCall(
      this.llmService.llmQuery(payload),
      (res) => {
        const answer = res?.response ?? '';

        this.data.bot_answer = answer;

        const sourceDoc = this.extractSourceDocs(res);

        this.refreshHistory(userId, questionArray, answer, sourceDoc);
      }
    );
  }

  private buildRefreshPayload(questionArray: string[]) {
    const base = {
      query: questionArray,
      bypass_cache: true,
      client_id: localStorage.getItem('company_id') ?? ''
    };

    return this.data?.group_ids?.length
      ? { ...base, class_id: this.data.group_ids }
      : base;
  }

  private extractSourceDocs(res: any): string {
    const docs = res?.source_documents || [];

    if (!docs.length) return '';

    this.source_doc = docs;
    this.data.source_doc = this.getSourcedoc_names(docs);

    return this.data.source_doc;
  }

  private updateBotData(answer: string, type: string): void {
    this.data.bot_answer = answer;
    this.data.query_type = type;
  }

  private refreshHistory(
    userId: string,
    questionArray: string[],
    answer: string,
    sourceDoc: string
  ): void {

    const botPayload = {
      user_id: userId,
      question: questionArray,
      answer,
      question_type: 'history',
      bot_type: 'bot',
      source_doc: sourceDoc,
      sequence_id: Date.now(),
      query_type: this.is_generic ? 'generic' : 'private'
    };

    const params = {
      history_id: this.data.history_id,
      user_id: userId
    };

    this.assistBotService.RefreshBotData(botPayload, params)
      .subscribe({
        next: (res: any) => {
          if (res?.success) {
            this.data.createdAt = new Date();
            this.data.search = false;

            this.alert.showAlertMessage({
              message: 'Your requested data refreshed successfully.'
            });
          }
        },
        error: (err) => console.error(err)
      });
  }

  cleanSourceParagraphs(): void {
    const raw = this.data?.source_paragraphs;

    if (!raw) return;

    let parsed: any[] = [];

    // Safe JSON parse
    try {
      parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch (e) {
      console.error('Invalid source_paragraphs JSON:', e);
      return;
    }

    if (!Array.isArray(parsed) || parsed.length === 0) return;

    const seenTexts = new Set<string>();

    const formatted = parsed
      .filter(item => {
        const text = item?.text?.trim();
        if (!text || seenTexts.has(text)) return false;

        seenTexts.add(text);
        return true;
      })
      .map(item => {
        const text = item?.text?.trim();
        const doc = item?.document_name ?? 'Unknown';

        return `${text} <span style="color: #1d72b2;">(Source: ${doc})</span>`;
      });

    const finalText = formatted.join(', ');

    this.cleanedSourceParagraphs = this.safedata(finalText);
  }

  openDialog() {

    this.dialogService.openListDialog(ListdialogComponent, {
      title: 'Save Document',
      btnOkText: 'Create',
      data: [
        { "label": "Save as a word document", "value": "word", "active": false },
        { "label": "Save as a pdf file ", "value": "pdf", "active": true }],
      onclose: (selectedList) => {
        if (selectedList) {

          let user_id: any = window.localStorage.getItem('user_id');
          let payload = {
            "user_id": parseInt(user_id),
            "question": this.data.question,
            "answer": this.data.bot_answer.replaceAll(/\*/g, "").replaceAll(/\#/g, ""),
            "question_type": selectedList['value'],
            "bot_type": this.data['bot_type'],
            "document_ids": this.data.document_ids,
            "query_type": this.data.query_type,
            "source_paragraphs": this.data.source_paragraphs,
            "sequence_id": new Date().valueOf()
          }

          this.assistBotService.BotFilegenerate(payload).subscribe((res: any) => {

            if (res['success']) {
              this.alert.showAlertMessage({ 'message': 'Your requested data file was generated successfully.' });
              // this.aiassistsComp.chatfileList.unshift(res['result']);
              this.assistBotService.chatHistoryList.unshift(res['result']);
              this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
            } else {
              this.alert.showAlertMessage(res);
              this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
            }
          }, (error: any) => {

            // this.alert.showAlertMessage(error['error']);

          });
        }

      }
    });

  }

  generateAudio() {
    let user_id: any = window.localStorage.getItem('user_id');
    this.dialogService.openListDialog(ListdialogComponent, {
      title: 'Create Audio',
      btnOkText: 'Create',
      data: [
        { "label": "English", "value": "English" },
        { "label": "Tamil ", "value": "Tamil" },
        { "label": "Hindi ", "value": "Hindi" },
        { "label": "Spanish ", "value": "Spanish" },
        { "label": "German", "value": "German" },
        { "label": "Malayalam", "value": "Malayalam" },
        { "label": "kannada", "value": "Kannada" },
        { "label": "French", "value": "French" },
        { "label": "Danish", "value": "Danish" }],

      onclose: (selectedList) => {

        let payload = {
          "user_id": parseInt(user_id),
          "question": this.data.question,
          "answer": this.data.bot_answer.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, " ").replace(/[\/\\#,+()$~.'":*?<>{}]/gi, ''),
          "question_type": "audio",
          "bot_type": this.data['bot_type'],
          "sequence_id": new Date().valueOf(),
          "language": selectedList['value']
        }


        this.assistBotService.BotFilegenerate(payload).subscribe((res: any) => {
          if (res['success']) {
            this.alert.showAlertMessage({ 'message': 'Your requested data audio file was generated successfully.' });
            //this.aiassistsComp.chatfileAudioList.unshift(res['result']);
            this.assistBotService.chatHistoryList.unshift(res['result']);
            this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
          } else {
            this.alert.showAlertMessage({ 'message': 'Audio File already exists', 'type': 2 });
            this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
          }
        }, (error: any) => {
          console.log("file generate error", error);
          // this.alert.showAlertMessage(error['error']);
        });
      }
    });
    /*  */
  }

  // callSummarization(data:any){
  //   let payload = {
  //     "text":data,
  //     "task":"summarization"
  //     };
  //   return this.http.post("https://document.canstringai.com:8443/ca-llm/multiple_task",payload);
  // }



  viewSourceDoc(docId: any) {
    this.assistBotService.getllmfile(docId).subscribe((res_blob: any) => {
      let d = new Date();
      var datestring = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + "_" +
        d.getHours() + "-" + d.getMinutes();
      this.alert.showAlertMessage({ 'message': 'Source document download', 'type': 2 });
      importedSaveAs(res_blob, datestring + ".pdf");
    });
  }

  safedata(data: string) {
    return this.sanitizer.bypassSecurityTrustHtml(data);
  }


  saveAsPdf(historyId: any, botData: any) {
    if (/^\s/.test(this.documentFileName) || this.documentFileName == undefined) {
      this.documentFileNameError = "Enter valid file name";
      return;
    }
    const payload = {
      bot_answer: this.quill.getSemanticHTML()
    }
    this.httpLoader.showLoader();
    this.assistBotService.updateAIBotHistory(historyId, payload).subscribe((response: any) => {
      console.log("edit", response);
      this.data = response['data'];
      this.documentFileNameError = "";
      this.closeModal();
      this.httpLoader.hideLoader();
      // this.alert.showAlertMessage(response);
      this.editBotHistoryId = null;
      let user_id: any = window.localStorage.getItem('user_id');
      let Filepayload = {
        "user_id": parseInt(user_id),
        "question": this.data.question,
        "answer": response['data']['bot_answer'],
        "question_type": "pdf",
        "bot_type": this.data['bot_type'],
        "document_file_name": this.documentFileName,
        "sequence_id": new Date().valueOf()
      }

      this.assistBotService.BotFilegenerate(Filepayload).subscribe((res: any) => {

        if (res['success']) {
          this.alert.showAlertMessage({ 'message': 'Your requested data file was generated successfully.' });
          // this.aiassistsComp.chatfileList.unshift(res['result']);
          this.assistBotService.chatHistoryList.unshift(res['result']);
          this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
        } else {
          this.alert.showAlertMessage(res);
          this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
        }
      }, (error: any) => {

        // this.alert.showAlertMessage(error['error']);
        this.alert.showAlertMessage({ 'message': 'Your requested data file already exists.', 'type': 2 });
        this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
      });
    });

  }


  saveAsDoc(historyId: any, botData: any) {
    if (/^\s/.test(this.documentFileName) || this.documentFileName == undefined) {
      this.documentFileNameError = "Enter valid file name";
      return;
    }
    // const payload = {
    //       bot_answer: this.editAIData
    //   }
    const payload = {
      bot_answer: this.quill.getSemanticHTML()
    }
    this.httpLoader.showLoader();
    this.assistBotService.updateAIBotHistory(historyId, payload).subscribe((response: any) => {
      console.log("edit", response);
      this.data = response['data'];
      this.closeModal();
      this.httpLoader.hideLoader();
      // this.alert.showAlertMessage(response);
      this.editBotHistoryId = null;
      let user_id: any = window.localStorage.getItem('user_id');
      let Filepayload = {
        "user_id": parseInt(user_id),
        "question": this.data.question,
        "answer": response['data']['bot_answer'],
        "question_type": "word",
        "bot_type": this.data['bot_type'],
        "document_file_name": this.documentFileName,
        "sequence_id": new Date().valueOf()
      }

      this.assistBotService.BotFilegenerate(Filepayload).subscribe((res: any) => {

        if (res['success']) {
          this.alert.showAlertMessage({ 'message': 'Your requested data file was generated successfully.' });
          // this.aiassistsComp.chatfileList.unshift(res['result']);
          // this.assistBotService.chatHistoryList.unshift(res['result']);
          this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
        } else {
          this.alert.showAlertMessage(res);
          this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
        }
      }, (error: any) => {

        // this.alert.showAlertMessage(error['error']);
        this.alert.showAlertMessage({ 'message': 'Your requested data file already exists.', 'type': 2 });
        this.assistBotService.historyListBheaviour.next({ "templateName": this.data['bot_type'] });
      });
    });
  }




  filterImages(str: any) {
    const imgRegExp = /(?:<img\s+src="(.*?)"[^.]*?\/?>|&lt;img\s+src="(.*?)"[^.]*?\/?&gt;)/gm;
    const images = [];
    let img;
    while ((img = imgRegExp.exec(str))) {
      images.push(img[1]);
    }
    return images;
  }

  htmltagsplit(data: any) {
    const htmlString = "The <span>quick</span> brown <b>fox</b> jumps.";
    //const parts = data.split(/(?=<[^>]+>)|(?<=<\/[^>]+>)/);
    const regex = /\s*(?<!\S)([^\s<>]+(?:\s+[^\s<>]+)*)(?!\S)\s*/;
    const parts = data.split(regex).filter(Boolean)
    console.log(parts);
    return parts;
  }



  ValidatefileName(event: any) {

    if (/^\s/.test(this.documentFileName) || this.documentFileName == undefined || this.documentFileName == "") {
      this.documentFileNameError = "Enter valid file name";
    } else {
      this.documentFileNameError = "";
    }
  }

  showSource(question: any) {
    if (question.indexOf("Private") != -1 && this.data.source_doc) {
      return true
    }
  }

  getSourcedoc_names(document_list: any) {
    let files_name: any = [];
    if (document_list.length > 0) {
      document_list.forEach((doc_key: any) => {
        if (doc_key["filename"]) {
          if (files_name.indexOf(doc_key["filename"]) == -1) {
            files_name.push(doc_key["filename"]);
          }
        }
      });

      return files_name.join(", ");
    }
  }

  modalFullScreen() {
    this.editorFullView = !this.editorFullView;
  }

  animateQuestion(Question: any) {
    return [Question];
  }

  formatQuestion(question: any): string {
    if (Array.isArray(question)) {
      return question.join(', ');
    }
    return question || '';
  }

  getSearch(source_paragraphs: any) {
    let answer: any = '';
    this.searchView = true;
    if (source_paragraphs?.length > 0) {
      source_paragraphs.forEach((element: any) => {
        answer = answer + " " + element['text'] + "<br><br>";
      });
    }

    return answer;
  }

  fileSources(source_doc: any) {
    let source_docment: any = '';
    if (source_doc.length > 0) {
      source_doc.forEach((element: any) => {
        source_docment = source_docment + " " + element['filename'] + ",";
      });
    }
    return source_docment.substring(0, source_docment.length - 1);
  }

  fileSources_para(source_paragraphs: any) {
    let source_docment: any = '';
    let duplicate_check: any = [];
    if (source_paragraphs?.length > 0) {
      source_paragraphs.forEach((element: any) => {
        if (duplicate_check.indexOf(element['document_name']) == -1) {
          source_docment = source_docment + " " + element['document_name'] + ",";
          duplicate_check.push(element['document_name']);
        }

      });
    }
    return source_docment.substring(0, source_docment.length - 1);
  }
  fileSources_para_text(source_paragraphs: any) {
    // console.log(source_paragraphs);

    let text: any = '';
    let duplicate_check: any = [];
    if (source_paragraphs.length > 0) {
      source_paragraphs.forEach((element: any) => {
        if (duplicate_check.indexOf(element['text']) == -1) {
          text = text + " " + element['text'] + "<span style='color: #1d72b2;'>( Source: " + element['document_name'] + ")</span>" + ",";
          duplicate_check.push(element['text']);
        }

      });
    } else {
      text = source_paragraphs;
    }
    return this.safedata(text.substring(0, text.length - 1));
  }
  toggleTextView() {
    this.showTextView = !this.showTextView;
  }
}
